import * as Yup from 'yup';

import { ALLOWED_CHARACTERS_REGEX, DECIMAL_REGEX } from '@/common/constants';

export const addRefDataSchema = () => {
    return (
        Yup.object({
            type: Yup.string()
                .trim()
                .required('Type is required')
                .max(50, 'Max length is 50 characters'),
            order: Yup.string()
                .trim()
                .required('Order is required')
                .matches(DECIMAL_REGEX, 'Order must contain only digits'),
            value: Yup.string()
                .trim()
                .required('Value is required')
                .matches(ALLOWED_CHARACTERS_REGEX, 'Input must only contain alphabets, numbers, commas, dots, slashes, and dashes.')
                .max(50, 'Max length is 50 characters'),
            name: Yup.string()
                .trim()
                .required('Name is required')
                .matches(ALLOWED_CHARACTERS_REGEX, 'Input must only contain alphabets, numbers, commas, dots, slashes, and dashes.')
        }));
}
